import React from 'react';

import {
  InboxItemContentApiVerificationRequest,
  InboxItemContentDataDisputeConsumer,
  InboxItemContentResources,
  InboxItemContentWrapper,
} from 'src/components/inboxItem';
import {
  VerificationRequestConsumer,
  VerificationRequestStatusBar,
} from 'src/components/verificationRequest';
import { InboxItemTypeWithResources } from 'src/constants/inbox';
import { useInboxItemById, useInboxItemParamId } from 'src/hooks/inboxItem';
import { useVerificationRequest } from 'src/hooks/verificationRequest';
import { InboxLayout } from 'src/layouts/InboxLayout';

import { ActivityLogsList } from '../activityLog';

export const InboxConsumer: React.FC = () => {
  const inboxItemId = useInboxItemParamId();
  const { inboxItem } = useInboxItemById(inboxItemId);

  const { verificationRequest } = useVerificationRequest({ inboxItemId });

  const verificationRequestStatus = verificationRequest?.status;

  const inboxItemContent = React.useMemo(() => {
    switch (inboxItem?.type) {
      case InboxItemTypeWithResources.DataDispute:
        return <InboxItemContentDataDisputeConsumer />;
      case InboxItemTypeWithResources.VerificationRequest:
        return <VerificationRequestConsumer />;
      case InboxItemTypeWithResources.Resources:
        return <InboxItemContentResources />;
      case InboxItemTypeWithResources.ApiVerificationRequest:
        return <InboxItemContentApiVerificationRequest />;
      default:
        return null;
    }
  }, [inboxItem?.type]);

  return (
    <InboxLayout>
      <InboxItemContentWrapper
        statusBar={
          inboxItem?.type === InboxItemTypeWithResources.VerificationRequest && (
            <VerificationRequestStatusBar
              status={verificationRequestStatus}
              isMyVerifyRequest={verificationRequest?.isMyVerifyRequest}
            />
          )
        }
        activityLog={<ActivityLogsList inboxItemId={inboxItemId} />}
      >
        {inboxItemContent}
      </InboxItemContentWrapper>
    </InboxLayout>
  );
};
